export const aboutData = {
    title: "Who I am",
    description1: "I am Salman, based in Islamabad, Pakistan. I am a software developer with a passion for creating innovative solutions that drive business growth. I have a Bachelor's degree in Computer Science and have been working in the tech industry for over 2 years. I have experience in developing web and mobile applications, and I am always eager to learn and explore new technologies.",

    description2: "I am a quick learner and a team player, and I am always looking for opportunities to collaborate with other developers to create amazing products. My proficiency spans Java, Python, C++, C#, React, React Native, Node.js, MongoDB, and SQL databases.",
    
    description3:"When I'm not coding, you'll find me unwinding over a game of snooker - a passion that helps me recharge. ",

    image: 4
}